import SceneProperties from "../data/SceneProperties";

class CrusherModel {
    bottom:number;
    left:number;
    height:number;
    width:number;
    offset:number;
    amplitude:number;
    init:number;

    constructor(bottom:number, left:number, height:number, width:number, offset = 0) {
        this.bottom = bottom / 100 * window.innerHeight;
        this.left = left / 100 * document.body.clientWidth * SceneProperties.totalWidthFact;
        this.height = height / 100 * window.innerHeight;
        this.width = width / 100 * document.body.clientWidth * SceneProperties.totalWidthFact;

        this.offset = offset;
        this.amplitude = this.height - (0.02 * window.innerHeight); //mtaching the foot css
        this.init = this.height;
    }
}

export default CrusherModel;